module.exports = __webpack_public_path__ + "img/icon-mic-blue.47164720.png";